module.exports = __webpack_public_path__ + "static/media/product_config.f6b2ed9e.png";